import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import EventLabel from "./EventLabel";

import MenuItem from "@material-ui/core/MenuItem";


export const GLNPopup = ({ onSuccess, list }) => {
    const [inputValue, setInputValue] = useState("");
    const glnList = list;
    const [selectedValue, setSelectedValue] = useState(glnList[0])


    const handleInput = (e) => {
        setInputValue(e.target.value);
    };

    const onClick = () => {
        onSuccess(selectedValue);
    };
    const onCancel = () => {
        onSuccess(-1);
    };

    const dropdownOnChange = (e, value) => {
        setSelectedValue(value);
        value != null ? onSuccess(value) : onSuccess(null);
    }


    //need to disable maxWidth on form-dialog-title
    return (
        <Dialog open={true} aria-labelledby="form-dialog-title" style={{maxWidth:"none"}}> 
            <DialogTitle id="form-dialog-title">
                <EventLabel name="SelectCompany" groupName="CMS.Payment" />
            </DialogTitle>
            <DialogContent>

                {glnList.length > 0 ?
                    glnList.map((qo) => {
                        return (
                            <MenuItem key={qo.companyId} onClick={(e) => dropdownOnChange(e, qo)} value={qo} style={{width: "100%"}}>
                                <ul name={"left"} className="cms-invoice-gln-left" style={{paddingInlineStart: "0%", whiteSpace: "pre-wrap"}}>
                                {qo.name}
                                </ul>
                                <ul name={"right"} className="cms-invoice-gln-right" style={{flex:"auto", textAlign:"right"}}>
                                {qo.gln}
                                </ul>
                            </MenuItem>
                        );
                    }) : null}

            </DialogContent>
            <DialogActions>
                {/* <Button onClick={onClick} color="primary">
                    <EventLabel name="PasswordDialogOk" groupName="CMS.PasswordDialog" />
                </Button> */}
                <Button onClick={onCancel} color="primary">
                    <EventLabel name="Cancel" groupName="CMS.Payment" />
                </Button>
            </DialogActions>
        </Dialog>
    );
};
